import React from "react";
import {
  Nav,
  NavItem,
  NavLink,
  Navbar,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import FeatherIcon from "feather-icons-react";
import { useNavigate } from "react-router-dom";

const useResponsiveTabs = () => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 992);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};

const ResponsiveTabs = ({ activeTab, setActiveTab, tabs, isResponsive = false }) => {
  const isMobile = useResponsiveTabs();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);

  if (!isResponsive || !isMobile) {
    return (
      <Nav tabs className="headerTabs">
        {tabs.map((tab) => (
          <NavItem key={tab.id}>
            <NavLink
              onClick={() => {
                setActiveTab(tab.id);
                navigate(tab.path);
              }}
              className={activeTab === tab.id ? "active-tab" : ""}
            >
              {tab.label}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
    );
  }

  return (
    <Navbar color="inherit" expand="xs" className="w-100 px-3 py-2">
      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} className="w-100">
        <DropdownToggle
          tag="button"
          className="min-w-100 text-start d-flex justify-between align-items-center btn btn-light border"
        >
          <span className="dropdownname">{tabs.find((t) => t.id === activeTab)?.label || "Select"}</span>
          <FeatherIcon
            icon={dropdownOpen ? "chevron-up" : "chevron-down"}
            style={{ minWidth: "24px", minHeight: "24px", padding: "0 5px" }}
          />
        </DropdownToggle>
        <DropdownMenu className="w-100">
          {tabs.map((tab) => (
            <DropdownItem
              key={tab.id}
              onClick={() => {
                setActiveTab(tab.id);
                navigate(tab.path);
                setTimeout(() => setDropdownOpen(false), 150);
              }}
              active={activeTab === tab.id}
              tag="a"
              className="text-wrap"
            >
              {tab.label}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </Navbar>
  );
};

export default ResponsiveTabs;
